import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody44.css';

import clientimg from '../images/case-study-client44.webp'
import outcome from '../images/outcome44.webp'

import sm1 from '../images/cs44so1.webp'
import sm2 from '../images/cs44so2.webp'
import sm3 from '../images/cs44so3.webp'
import sm4 from '../images/cs44so41.webp'
import sm5 from '../images/cs44so42.webp'
import sm6 from '../images/cs44so5.webp'


const Casestudybody44 = () => {

    return (
        <>
        <section className='casestudybody44-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A Software-as-a-Service (SaaS) focused operator of tech companies growing tech ecosystem by investing across high potential technology and software businesses   </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The PE firm sought to raise capital from private lenders to further invest in company they had signed exclusivity agreements with. To facilitate this, we undertook a detailed and thorough retention analysis across the entire portfolio, providing prospective investors with transparent insights into customer retention and churn dynamics</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody44-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Portfolio Revenue Consolidation: </h4>
                          <p><span style={{color:"#03A393",fontWeight:700}}> Collected, standardized</span> and <span style={{color:"#03A393",fontWeight:700}}> consolidated granular</span> customer-level revenue data across 12 portfolio companies to conduct unified customer analysis. This ensured <span style={{color:"#03A393",fontWeight:700}}> consistency across data, time periods</span> and <span style={{color:"#03A393",fontWeight:700}}> revenue classifications foundational</span> for a reliable analysis</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Revenue Stream Segmentation:</h4>
                          <p>Each company's revenue was systematically reviewed to accurately and consistently categorize customer revenue into two broad heads <span style={{color:"#03A393",fontWeight:700}}> “Recurring”</span> and <span style={{color:"#03A393",fontWeight:700}}> “Re-occurring”</span>. This segmentation provided a clear view of revenue quality of customer and was aligned well with the client expectations<span style={{color:"#03A393",fontWeight:700}}> </span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Advanced Retention & Churn Modeling:</h4>
                          <p>Developed a full-scale retention model for the client calculating y-o-y and m-o-m retention and churn metrics of the overall portfolio. This enabled a granular assessment of <span style={{color:"#03A393",fontWeight:700}}> customer loyalty, expansion opportunities</span> and the <span style={{color:"#03A393",fontWeight:700}}> long-term value proposition</span> of the portfolio</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Dynamic Scenario Planning:</h4>
                          <p>Created an interactive control for the client that allowed them <span style={{color:"#03A393",fontWeight:700}}> to dynamically include or exclude portfolio companies</span> facilitating real-time scenario analysis tailored to the investor expectations</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Collaborative Model Refinement:</h4>
                          <p>Collaborated with the <span style={{color:"#03A393",fontWeight:700}}> client internal investment</span> and <span style={{color:"#03A393",fontWeight:700}}> finance teams</span> to <span style={{color:"#03A393",fontWeight:700}}> refine logic, adjust revenue classifications, validate customer quality</span> and <span style={{color:"#03A393",fontWeight:700}}> enhance model precision</span> - ensuring outputs aligned with the client's fundraising narrative and investor standards</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <div className='imgrow'>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                        </div>
                        <img src={sm6} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody44-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered an investor-ready retention analysis model showcasing portfolio's revenue strength, customer stability and long-term value creation enabling the client raise fund. The dynamic toggling feature allowed the PE firm to tailor insights to boost investor confidence</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody44
